/* unplugin-vue-components disabled */import { render } from "./PlatformPreview.vue?vue&type=template&id=1097e7c2&scoped=true&ts=true"
import script from "./PlatformPreview.vue?vue&type=script&lang=ts"
export * from "./PlatformPreview.vue?vue&type=script&lang=ts"

import "./PlatformPreview.vue?vue&type=style&index=0&id=1097e7c2&lang=scss"
import "./PlatformPreview.vue?vue&type=style&index=1&id=1097e7c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1097e7c2"]])

export default __exports__